import { ResponsiveImage } from '~/graphql/fragments'
export const queryLocations = /* GraphQL */ `
  ${ResponsiveImage}
  query Locations(
    $locale: SiteLocale
    $first: IntType = 100
    $skip: IntType
    $allInCategory: [ItemId]
    $allInCountry: [ItemId]
    $excludeSlugs: [String]
    $publishTranslation: BooleanType = true
  ) {
    _allLocationsMeta(
      locale: $locale
      filter: {
        category: { in: $allInCategory }
        country: { in: $allInCountry }
        publishTranslation: { eq: $publishTranslation }
        slug: { notIn: $excludeSlugs }
      }
    ) {
      count
    }
    allLocations(
      locale: $locale
      first: $first
      skip: $skip
      filter: {
        category: { in: $allInCategory }
        country: { in: $allInCountry }
        publishTranslation: { eq: $publishTranslation }
        slug: { notIn: $excludeSlugs }
      }
    ) {
      __typename
      _modelApiKey
      id
      title
      imageGallery {
        alt
        url
        title
        width
        height
        responsiveImage(imgixParams: { auto: compress, crop: focalpoint, fit: crop, w: 1440 }) {
          ...ResponsiveImage
        }
      }
      category {
        _modelApiKey
        __typename
        id
        name
        slug
      }
      country {
        _modelApiKey
        __typename
        id
        name
        locale
        slug
      }
      html
      metadata
      generalInfo
      slug
      publishTranslation
    }
  }
`
